import { render, staticRenderFns } from "./SuppliersDetails.vue?vue&type=template&id=2b518db1&scoped=true&"
import script from "./SuppliersDetails.vue?vue&type=script&lang=js&"
export * from "./SuppliersDetails.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersDetails.vue?vue&type=style&index=0&id=2b518db1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b518db1",
  null
  
)

export default component.exports